import { handleActions } from 'redux-actions';
import { NAMES as SERVER_PREMIUM_INFO_GET } from 'shared/redux/server/actions/premium-info/get';


export default handleActions({
  [SERVER_PREMIUM_INFO_GET.SUCCESS]: (state, { payload }) => payload.response,
}, null);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/premium-info.js